import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { PatchScript } from '@pos-refacto/patchscript-with-react';

import { createConfirmation } from 'actions/Confirmation';
import { RootState } from 'reducers';
import { getCafaEntry } from 'reducers/cafaConfigs';
import { INTEGRATION_TYPES, INTEGRATIONS } from 'constants/CAFA';
import { printPatchscript } from 'actions/integrations/printer';

import { Autoprint } from '../types';

export function generatePatchscriptFromString(str: string): PatchScript {
  return str.split('\n').map(text => ({
    align: 'center',
    pieces: [{ text: text.trim() }],
    type: 'text',
  }));
}

const print = (receipt: string) => async (
  dispatch: ThunkDispatch<RootState, unknown, Action>,
) => {
  const patchscript = generatePatchscriptFromString(receipt);
  dispatch(printPatchscript(patchscript));
};
const automaticActionAfter = 15000;
function getExtraConfirmationProps(autoprint: Autoprint) {
  switch (autoprint) {
    case 'reject':
    case 'resolve':
      return {
        automaticAction: autoprint,
        automaticActionAfter,
      };
    default:
      return {};
  }
}

export default (clientR: string) => async (
  dispatch: ThunkDispatch<RootState, unknown, Action>,
  getState: () => RootState,
) => {
  const { value: config = {} } =
    getCafaEntry(
      INTEGRATIONS.payment.verifone,
      INTEGRATION_TYPES.payment,
    )(getState()) || {};
  const { autoprint = '-' } = config;

  await new Promise((resolve, reject) =>
    dispatch(
      createConfirmation(resolve, reject, {
        title: 'Print Client Receipt',
        body: 'Print receipt copy for the client?',
        ...getExtraConfirmationProps(autoprint),
      }),
    ),
  )
    .then(() => dispatch(print(clientR)))
    .catch(() => {
      // Do nothing
    });
};
